import { VenueState, VenuesData } from '@/types/Venue';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: VenueState = {
  venuesData: { totalPages: 0, page: 1, data: null, searchText: '', filterValue: 0, sortKey: 'id', sortDirection: 'desc' },
};

const venueSlice = createSlice({
  name: 'venues',
  initialState,
  reducers: {
    setVenuesData: (state, action: PayloadAction<VenuesData>) => {
      state.venuesData = action.payload;
    },
    setVenuesPageAction: (state, action: PayloadAction<number>) => {
      state.venuesData.page = action.payload;
    },
    archiveVenueAction: (state, action: PayloadAction<number>) => {
      if (state.venuesData.data) {
        state.venuesData.data = state.venuesData.data.filter(venue => venue.id !== action.payload);
      }
    },
    setVenueSearchTextAction: (state, action: PayloadAction<string>) => {
      state.venuesData.searchText = action.payload;
      state.venuesData.page = 1;
    },
    setVenueFilterValueAction: (state, action: PayloadAction<number>) => {
      state.venuesData.filterValue = action.payload;
    },
    setVenuesSortAction: (state, action: PayloadAction<{ sortKey: string; sortDirection: 'asc' | 'desc' }>) => {
      state.venuesData.sortKey = action.payload.sortKey;
      state.venuesData.sortDirection = action.payload.sortDirection;
    },

    clearVenueStateAction: () => initialState,
  },
});

export const {
  setVenuesData,
  setVenuesPageAction,
  archiveVenueAction,
  setVenueSearchTextAction,
  clearVenueStateAction,
  setVenueFilterValueAction,
  setVenuesSortAction,
} = venueSlice.actions;

export default venueSlice.reducer;
